// Copyright The Linux Foundation and each contributor to LFX.
// SPDX-License-Identifier: MIT
import { AlertService } from './../../../../core/services/alert.service';
import { UserGroupsState } from '@app/access-management/state/user-details/user-details.interfaces';
import { GroupsService } from './../../../core/services/group.service';
import { UserState } from './../../../state/user-details/user-details.interfaces';
import { Component, OnInit, Input, ViewChild, AfterViewInit } from '@angular/core';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { GeneralDeleteModalComponent } from '@app/access-management/shared/delete-modal/delete-modal.component';
import { UserDetailsFacadeService } from '@app/access-management/state/user-details/user-details.facade';
import { DataTableAjaxComponent } from '@app/shared/data-table-ajax/data-table-ajax.component';
import { UserGroup } from '@app/core/services/user.service';

@Component({
  selector: 'app-user-details-groups-tab',
  templateUrl: './user-details-groups-tab.component.html'
})
export class UserDetailsGroupsTabComponent implements OnInit, AfterViewInit {
  @Input() groups: any[] | undefined = undefined;
  @Input() username: string | undefined;

  @ViewChild('actionTemplate') actionTemplate: any;
  @ViewChild('dataTableAjax') dataTableAjax!: DataTableAjaxComponent;

  columns: any[] = [];

  constructor(
    private modalService: NgbModal,
    private groupsService: GroupsService,
    private alertService: AlertService
  ) {}

  ngOnInit(): void {}

  trackColumns(id: string) {
    return id;
  }

  ngAfterViewInit(): void {
    this.loadColumns();
  }

  loadColumns() {
    this.columns = [
      {
        name: 'Group',
        prop: 'name',
        cellClass: 'ml-8 text-info',
        headerClass: 'ml-8',
        flexGrow: 2
      },
      {
        name: 'Organization Name',
        prop: 'account_name',
        cellClass: 'ml-8 text-info',
        headerClass: 'ml-8',
        flexGrow: 2
      },
      {
        name: 'Actions',
        cellTemplate: this.actionTemplate,
        sortable: false,
        flexGrow: 1
      }
    ];
  }

  onRemoveRow(row: UserGroup) {
    const ModalFixture = this.modalService.open(GeneralDeleteModalComponent, {
      centered: true,
      windowClass: 'no-border'
    });
    const modal: GeneralDeleteModalComponent = ModalFixture.componentInstance;

    modal.observable = this.groupsService.deleteUserFromGroup(row.group_id, row.user_group_id);

    modal.onSuccessRemove = () => {
      this.dataTableAjax.refreshTable();
      this.alertService.success('Group Delete succeed');
      modal.close();
    };

    modal.onFailRemove = () => {
      this.alertService.error('Group Delete failed');
    };
  }
}



// WEBPACK FOOTER //
// ./src/app/access-management/users/user-details/user-details-groups-tab/user-details-groups-tab.component.ts